import {Model, ModelMixin} from '../../common/model.class';
import {Address} from '../../common/values/address.class';
import moment = require('moment');
import Moment = moment.Moment;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class PremedicalEducation extends ModelMixin() implements Model<PremedicalEducation> {

    TYPE = PremedicalEducation;

    institution?: string;
    address: Address = new Address();
    degree?: string;
    graduationDate?: Moment;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.graduationDate) jsonData.graduationDate = moment(jsonData.graduationDate);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/premedical/premedical-education.model.ts